(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const sliderEl = document.querySelector('.av-banner-swiper');
    if (!sliderEl || typeof Swiper === 'undefined') return;

    const section      = sliderEl.closest('.av-banner-slider');
    const autoplay     = section.dataset.autoplay === 'true';
    const delay        = parseInt(section.dataset.autoplayDelay, 10) || 4000;
    const effect       = section.dataset.effect || 'slide';
    const hasPagination = !!sliderEl.querySelector('.av-banner-pagination');

    new Swiper('.av-banner-swiper', {
      effect: effect,
      loop: true,
      speed: 600,
      grabCursor: true,
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      },
      navigation: {
        prevEl: '.av-banner-nav--prev',
        nextEl: '.av-banner-nav--next',
      },
      pagination: hasPagination
        ? { el: '.av-banner-pagination', clickable: true }
        : false,
      autoplay: autoplay
        ? { delay: delay, disableOnInteraction: false, pauseOnMouseEnter: true }
        : false,
      fadeEffect: effect === 'fade' ? { crossFade: true } : undefined,
    });
  });
})();